
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import styles from '../core-exchange.module.scss';
export const metadata = {
  toc: true,
  subnav: true,
  title: 'App Directory',
  layout: 'guide',
  description: 'See which applications your customers are connected to',
  parentTocLevel: 2,
  childTocLevel: 3,
  secondLevelToc: true,
  alwaysExpand: true
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Image = makeShortcode("Image");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className={styles.page}>
      <Header title='App Directory' subtitle={metadata.description} mdxType="Header" />
      <h2 {...{
        "id": "overview"
      }}>{`Overview`}</h2>
      <p>{`App Directory shows which Plaid-powered applications your customers are connected to, including app categories and the number of connections. It is not required for launch, but it is recommended for monitoring connections and understanding how your customers interact with Plaid-powered applications.`}</p>
      <p>{`Plaid manages application onboarding and risk review, so you get this visibility without implementing `}<a parentName="p" {...{
          "href": "https://datatracker.ietf.org/doc/html/rfc7591"
        }}>{`Dynamic Client Registration`}</a>{`.`}</p>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Account type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Access`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Single institution`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`No-code feature in the Data Partner Dashboard`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Platform (multi-institution)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "/core-exchange/docs/permissions-manager/app-directory"
              }}>{`App Directory API`}</a>{` only — no Dashboard UI for platforms today`}</td>
          </tr>
        </tbody>
      </table>
      <h2 {...{
        "id": "dashboard-access-single-institution-only"
      }}>{`Dashboard access (single institution only)`}</h2>
      <p>{`The App Directory displays details about the apps your customers are connected to, including categories and the number of connections.`}</p>
      <Image src='/assets/img/core-exchange/app-directory.png' alt='App Directory showing connected applications with categories and connection counts' caption='View connected applications and their details' expandable={true} mdxType="Image" />
      <h2 {...{
        "id": "managing-consent"
      }}>{`Managing consent`}</h2>
      <p>{`To look up authorization records, revoke a customer's consent, or configure webhooks for connection and disconnection events, see `}<a parentName="p" {...{
          "href": "/core-exchange/docs/consent-management"
        }}>{`Consent management`}</a>{`.`}</p>
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 2,
        title: "Overview",
      },
{
        id: "dashboard-access-single-institution-only",
        level: 2,
        title: "Dashboard access (single institution only)",
      },
{
        id: "managing-consent",
        level: 2,
        title: "Managing consent",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
